import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { AccountInfo } from '@azure/msal-browser';
import { RouterModule } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PartnerUserDto } from '../../models/partner.model';
import { PartnerService } from '../../services/partner.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, OnDestroy {
  userMenuOpen = false;
  user: AccountInfo | null = null;
  partnerUser: PartnerUserDto | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private partnerService: PartnerService
  ) { }

  ngOnInit() {
    this.authService.user$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(user => {
        this.user = user;
        if (user) {
          this.fetchPartnerUser();
        } else {
          this.partnerUser = null;
        }
      });
  }

  fetchPartnerUser() {
    this.partnerService.getMe()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.partnerUser = data;
        },
        error: (err) => {
          console.error('Error fetching partner user details', err);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Close user dropdown when clicking outside
    const target = event.target as HTMLElement;
    if (!target.closest('.user-dropdown')) {
      this.userMenuOpen = false;
    }
  }

  toggleUserMenu(event: Event) {
    event.stopPropagation();
    this.userMenuOpen = !this.userMenuOpen;
  }

  closeAllMenus() {
    this.userMenuOpen = false;
  }

  login() {
    this.authService.loginRedirect();
  }

  logout() {
    this.authService.logoutRedirect();
  }

  getUserInitials(): string {
    if (!this.user?.name) return 'U';
    return this.user.name.split(' ').map(n => n.charAt(0)).join('').toUpperCase().substring(0, 2);
  }

  getUserEmail(): string {
    if (!this.user) return '';

    const idTokenClaims = (this.user as any)?.idTokenClaims;
    const emailFromClaims = idTokenClaims?.email || idTokenClaims?.preferred_username || idTokenClaims?.upn;

    return this.user.username ||
      emailFromClaims ||
      this.user.localAccountId ||
      this.user.homeAccountId?.split('.')[0] ||
      this.user.name ||
      '';
  }
}


